import { render, staticRenderFns } from "./info_pc.vue?vue&type=template&id=65a76d4a&scoped=true&"
import script from "./info_pc.vue?vue&type=script&lang=js&"
export * from "./info_pc.vue?vue&type=script&lang=js&"
import style0 from "./info_pc.vue?vue&type=style&index=0&id=65a76d4a&scoped=true&lang=css&"
import style1 from "./info_pc.vue?vue&type=style&index=1&id=65a76d4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a76d4a",
  null
  
)

export default component.exports